export default function updatePricing() {
  window.Taxamo.scanPrices('.my-price', {
    priceTemplate: '${totalAmount}<br/><small>Cost: ${amount} VAT: ${taxAmount} (${taxRate}%)</small>', // eslint-disable-line no-template-curly-in-string
    noTaxTitle: 'No tax applied here',
  });
}